module.exports = __webpack_public_path__ + "static/img_9894-90a07fce512c00b28845c4d006e4da98.webp";